var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "top-nav" } }, [
    _vm.ready
      ? _c("nav", { staticClass: "top-nav", style: _vm.headerBG }, [
          _c(
            "div",
            { staticClass: "top-nav__back-button" },
            [
              _vm.navigationHelper.showBackButton
                ? _c("vs-icon-button", {
                    attrs: {
                      title: "Back",
                      icon: "arrow-left",
                      disabled: _vm.processing,
                      processing: _vm.processing
                    },
                    on: { click: _vm.handleNavigateBack }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "top-nav__links-container",
              class: {
                "top-nav__links-container--has-links":
                  _vm.navigationHelper.navLinks.length
              }
            },
            _vm._l(_vm.navigationHelper.navLinks, function(link) {
              return _c(
                "router-link",
                {
                  key: _vm.linkText(link),
                  staticClass: "top-nav__link",
                  attrs: { to: _vm.linkPath(link) }
                },
                [_vm._v(_vm._s(_vm.linkText(link)))]
              )
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "top-nav__actions" },
            [
              _c(
                "vs-layout",
                {
                  attrs: {
                    "vert-align-center-xs": "vert-align-center-xs",
                    "no-gutter": "no-gutter"
                  }
                },
                [
                  _c("help-logo", { on: { click: _vm.handleHelpClick } }),
                  _c("div", { staticClass: "top-nav__dropdown" }, [
                    _c("i", {
                      staticClass:
                        "mdi mdi-menu-down top-nav__dropdown-trigger",
                      on: {
                        click: function($event) {
                          _vm.menuOpen = !_vm.menuOpen
                        }
                      }
                    }),
                    _c("i", {
                      staticClass: "mdi mdi-menu-down top-nav__dropdown-caret",
                      class: {
                        "top-nav__dropdown-caret--visible": _vm.menuOpen
                      }
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "top-nav__dropdown-menu",
                        class: { "top-nav__dropdown-menu--open": _vm.menuOpen }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "top-nav__dropdown-user" },
                          [
                            _vm.currentUser.email === _vm.currentUserEmail
                              ? [
                                  _c("h6", [
                                    _vm._v(_vm._s(_vm.currentUser.name))
                                  ]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.currentUser.email))
                                  ])
                                ]
                              : [
                                  _c("h6", [
                                    _vm._v(_vm._s(_vm.currentUserEmail))
                                  ])
                                ]
                          ],
                          2
                        ),
                        _vm.showMyOrdersLink
                          ? _c(
                              "a",
                              {
                                staticClass: "vs-link top-nav__dropdown-item",
                                attrs: {
                                  target: "_blank",
                                  href: _vm.profileUrl
                                }
                              },
                              [
                                _c("span", { staticClass: "mdi mdi-cart" }),
                                _c("span", [_vm._v(" My Orders")])
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            staticClass: "vs-link top-nav__dropdown-item",
                            attrs: { tabindex: "0", title: "Logout" },
                            on: { click: _vm.logout }
                          },
                          [
                            _c("span", { staticClass: "mdi mdi-logout" }),
                            _c("span", [_vm._v(" Log Out")])
                          ]
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }